<template>
  <div id="user-list">
    <pausas-add-new
      :edit="edit"
      :open-add-pausas.sync="openAddPausas"
      @refetch-data="getPausas"
    />

    <contadores
      :total="contadores.total"
      :ativos="contadores.ativos"
      :inativos="contadores.inativos"
      @alterarFiltro="atualizarFiltro"
    />

    <v-card>
      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-text-field
          v-model.trim="search"
          placeholder="Pesquisar"
          outlined
          hide-details
          dense
          class="user-search me-3 mb-4"
          @keyup="getPausas"
        />

        <v-spacer />

        <v-btn
          color="success"
          class="mb-4 px-4"
          @click="addPausas"
        >
          <v-icon
            left
            size="25"
            class="mr-1"
          >
            {{ icons.mdiPlus }}
          </v-icon>
          <span>Criar Pausa</span>
        </v-btn>
      </v-card-text>

      <v-col cols="12">
        <div style="min-height: 4px">
          <v-progress-linear
            v-if="loading"
            indeterminate
          />

          <table-pausas-list
            :items="pausas"
            :headers="headers"
            @confirmar-inativacao="getPausas"
            @refetch-data="getPausas"
          />
        </div>
      </v-col>
    </v-card>
  </div>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api'
import { mdiAccount, mdiPlus } from '@mdi/js'
import Contadores from '@/components/contadores/Contadores.vue'
import TablePausasList from '@/components/tables/TablePausasList.vue'
import PausasAddNew from '@/views/pausas/EditPausaDialog.vue'
import PausasService from '@/services/modules/PausasService'

export default {
  components: {
    Contadores,
    TablePausasList,
    PausasAddNew,
  },

  setup() {
    const opcoes = [
      { title: 'Inativos', value: 'false' },
      { title: 'Ativos', value: 'true' },
      { title: 'Todos', value: '' },
    ]

    const headers = [
      { text: 'NOME', value: 'nome' },
      { text: 'DESCRIÇÃO', value: 'descricao' },
      { text: 'STATUS', value: 'ativo' },
      {
        text: 'OPÇÔES',
        value: 'actions',
        align: 'center',
      },
    ]

    const openAddPausas = ref(false)
    const edit = ref(false)
    const pausas = ref([])
    const loading = ref(false)
    const search = ref('')
    const filtroStatus = ref('')
    const contadores = ref({
      total: 0,
      ativos: 0,
      inativos: 0,
    })

    async function getPausas() {
      try {
        pausas.value = await PausasService.get()

        contadores.value.total = pausas.value.length
        contadores.value.ativos = pausas.value.filter(ativo => ativo.ativo).length
        contadores.value.inativos = pausas.value.filter(ativo => !ativo.ativo).length

        if (search.value) {
          pausas.value = pausas.value.filter(it => it.nome.toLowerCase().includes(search.value.toLowerCase()))
        }
        if (filtroStatus.value) {
          pausas.value = pausas.value.filter(e => e.ativo === filtroStatus.value || e.ativo.toString() === filtroStatus.value)
        }
        pausas.value.sort((a, b) => new Date(b.dataCadastro) - new Date(a.dataCadastro))

        setTimeout(() => {
          loading.value = false
          openAddPausas.value = false
        }, 1000)
      } finally {
        loading.value = false
      }
    }

    onMounted(getPausas)

    function addPausas() {
      openAddPausas.value = true
    }

    function atualizarFiltro(item) {
      filtroStatus.value = item
      getPausas()
    }

    return {
      openAddPausas,
      edit,
      opcoes,
      headers,
      pausas,
      loading,
      search,
      filtroStatus,
      contadores,
      getPausas,
      addPausas,
      atualizarFiltro,
      icons: {
        mdiPlus,
        mdiAccount,
      },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
